import React from 'react';

import classNames from 'classnames';

import styles from './styles.module.scss';

export const List: React.FC<sharedComponents.List> = ({ list, render, className, testId }) => (
  <ul data-testid={testId} className={classNames(styles.list, className)}>
    {list.map((listItem, index) => (
      <li
        className={styles.listItem}
        key={index} // eslint-disable-line
      >
        {render(listItem)}
      </li>
    ))}
  </ul>
);
